import { useRef } from "react"
import PropTypes from "prop-types"
import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"
import TextEditor from "components/admin/TextEditor"
import { Pane } from "components/ui"
import { Box, StackView } from "@planningcenter/tapestry-react"

const AttendeeTypeConfirmationEmail = ({ onChange, value }) => {
  const richTextEditorRef = useRef()

  const handleChange = e => onChange(e.target.value)

  return (
    <Pane>
      <Pane.Header axis="vertical" alignment="start">
        <StackView axis="horizontal" spacing={1}>
          <Pane.Title>Custom confirmation message</Pane.Title>
          <Box position="relative" top="2px">
            <HelperShelfTrigger id="custom-confirmation" />
          </Box>
        </StackView>
        <Box>
          <HelperShelfMessage id="custom-confirmation">
            When someone registers for this selection, this message will be inserted into the
            confirmation email they receive.
          </HelperShelfMessage>
        </Box>
      </Pane.Header>
      <Pane.Body alignment="stretch" paddingTop={0}>
        <TextEditor
          richTextEditorRef={richTextEditorRef}
          name="confirmationEmailMessage"
          onChange={handleChange}
          value={value}
        />
      </Pane.Body>
    </Pane>
  )
}

AttendeeTypeConfirmationEmail.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

export default AttendeeTypeConfirmationEmail
